import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insurance-landing',
  templateUrl: './insurance-landing.component.html',
  styleUrls: ['./insurance-landing.component.css']
})
export class InsuranceLandingComponent implements OnInit {

  beneficios = [
    {
      icon: '✅',
      titulo: 'Seguro válido para visado',
      descripcion: 'Cumple con todos los requisitos exigidos por consulados y extranjería.'
    },
    {
      icon: '🖥️',
      titulo: '100% digital',
      descripcion: 'Contrata tu seguro sin moverte de casa, desde cualquier país.'
    },
    {
      icon: '📄',
      titulo: 'Certificado en PDF',
      descripcion: 'Recibe el comprobante oficial que necesitas presentar en tu cita.'
    },
    {
      icon: '🤝',
      titulo: 'Asesoría personalizada',
      descripcion: 'Te acompañamos paso a paso en todo el proceso de contratación.'
    },
    {
      icon: '🔐',
      titulo: 'Pago seguro',
      descripcion: 'Tu información está protegida. Enlace de pago único y verificado.'
    },
    {
      icon: '⚡',
      titulo: 'Rápido y sin complicaciones',
      descripcion: 'Gestionamos tu solicitud en tiempo récord para que puedas avanzar.'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  goToCalendly() {
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02')
  }

  goToWebapp(){
    window.open('https://app.voyjaleas.com/#/sub-app/health-helper');
  }

}
